module.exports = __webpack_public_path__ + "assets/img/integralBlingBox.62108ac2.png";